"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Icon from "./icon.js";
export const GithubIcon = React.forwardRef(function GithubIcon(props, ref) {
    return (_jsx(Icon, Object.assign({ ref: ref }, props, { children: _jsx("path", { d: "M9.658 19.146C4.902 20.573 4.902 16.769 3 16.293M16.316 22v-3.681c.072-.917-.253-1.822-.894-2.483 2.987-.333 6.126-1.465 6.126-6.658 0-1.328-.511-2.605-1.427-3.567a4.82 4.82 0 0 0-.086-3.586s-1.122-.333-3.719 1.408c-2.18-.591-4.478-.591-6.658 0-2.597-1.741-3.719-1.408-3.719-1.408a4.82 4.82 0 0 0-.086 3.586c-.923.969-1.434 2.258-1.427 3.595 0 5.155 3.139 6.287 6.126 6.658-.633.654-.958 1.546-.894 2.454V22" }) })));
});
export default GithubIcon;
//# sourceMappingURL=github.js.map